var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.032 14C8.41647 14 9.76985 14.4105 10.921 15.1797C12.0721 15.9489 12.9693 17.0421 13.4992 18.3212C14.029 19.6003 14.1676 21.0078 13.8975 22.3656C13.6274 23.7235 12.9607 24.9708 11.9817 25.9497C11.0028 26.9287 9.7555 27.5954 8.39763 27.8655C7.03977 28.1356 5.6323 27.997 4.35322 27.4672C3.07413 26.9373 1.98088 26.0401 1.21171 24.889C0.442543 23.7378 0.032 22.3845 0.032 21L0 20C0 16.287 1.475 12.726 4.10051 10.1005C6.72602 7.475 10.287 6 14 6V10C12.6862 9.99647 11.3847 10.2534 10.1709 10.756C8.95699 11.2586 7.85479 11.9968 6.928 12.928C6.56779 13.2875 6.2355 13.674 5.934 14.084C6.292 14.028 6.658 13.998 7.03 13.998L7.032 14ZM25.032 14C26.4165 14 27.7699 14.4105 28.921 15.1797C30.0721 15.9489 30.9693 17.0421 31.4992 18.3212C32.029 19.6003 32.1676 21.0078 31.8975 22.3656C31.6274 23.7235 30.9607 24.9708 29.9818 25.9497C29.0028 26.9287 27.7555 27.5954 26.3976 27.8655C25.0398 28.1356 23.6323 27.997 22.3532 27.4672C21.0741 26.9373 19.9809 26.0401 19.2117 24.889C18.4425 23.7378 18.032 22.3845 18.032 21L18 20C18 16.287 19.475 12.726 22.1005 10.1005C24.726 7.475 28.287 6 32 6V10C30.6862 9.99647 29.3847 10.2534 28.1709 10.756C26.957 11.2586 25.8548 11.9968 24.928 12.928C24.5678 13.2875 24.2355 13.674 23.934 14.084C24.292 14.028 24.658 14 25.032 14Z",
    fill: "#FFB539",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.fd42b09d4e316bbe7521815c7792e44a.svg";
export { ForwardRef as ReactComponent };